import { render, staticRenderFns } from "./UserSignatureManager.vue?vue&type=template&id=23f4af5e&scoped=true"
import script from "./UserSignatureManager.vue?vue&type=script&lang=js"
export * from "./UserSignatureManager.vue?vue&type=script&lang=js"
import style0 from "./UserSignatureManager.vue?vue&type=style&index=0&id=23f4af5e&prod&lang=css"
import style1 from "./UserSignatureManager.vue?vue&type=style&index=1&id=23f4af5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f4af5e",
  null
  
)

export default component.exports